import {LayoutContent, LayoutHeader, LayoutTopbar} from "@tinct/web-layout";
import {TabNavLinks} from "@tinct/web-components";
import {Outlet} from "react-router-dom";
import {useCurrentWorkspaceUrlPrefix} from "@tinct/core-workspace";

const getTabItems = (baseUrl: string) => [
  { title: 'Company Profile', url: `${baseUrl}/settings/brand-guidelines/profile` },
  { title: 'Value & Messaging', url: `${baseUrl}/settings/brand-guidelines/value-and-messaging` },
  { title: 'Visual Identity', url: `${baseUrl}/settings/brand-guidelines/visual-identity` },
  { title: 'Compliance', url: `${baseUrl}/settings/brand-guidelines/compliance` },
];

export const EditBrandPage = () => {

  const baseUrl = useCurrentWorkspaceUrlPrefix();

  return (
    <div>
      <header className="sticky top-0 z-30">
        <LayoutTopbar/>
      </header>
      <LayoutContent>
        <LayoutHeader
          pageTitle={"Brand Guidelines"}

        />
        <TabNavLinks items={getTabItems(baseUrl)} />
        <div className="flex flex-col h-full max-w-4xl">
          <div className="flex-1">
            <Outlet />
          </div>
        </div>
      </LayoutContent>
    </div>
  );
}
